import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a0352684"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-invite-sender" }
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  class: "invite-status-row-text col-sm-8 col-sm-offset-1",
  "data-test": "tis-sent-tag-email"
}
const _hoisted_5 = { class: "col-sm-2 send-status-column" }
const _hoisted_6 = {
  key: 0,
  class: "invite-status label label-success",
  "data-test": "tis-sent-tag-completed"
}
const _hoisted_7 = {
  key: 1,
  class: "invite-status label label-warning",
  "data-test": "tis-sent-tag-sent"
}
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "glyphicon glyphicon-trash"
}
const _hoisted_10 = {
  key: 1,
  "data-test": "confirm-delete-pending-invite"
}
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "input-wrapper form-control form-control-lg" }
const _hoisted_13 = { class: "col-sm-2 col-xs-12 send-button" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "hidden-xs" }
const _hoisted_16 = { class: "visible-xs-inline-block" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "col-sm-10 col-sm-offset-1" }
const _hoisted_19 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_20 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_21 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_22 = {
  key: 3,
  class: "text-danger"
}

import axios from "axios";
import { useVuelidate } from "@vuelidate/core";
import { email, required } from "@vuelidate/validators";
import { computed, ref, watch } from "vue";
import UserTag from "../user-tag";
import { EmailRegEx } from "./useInviteControlBase";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-invite-sender',
  props: {
    userTags: { default: () => [] as UserTag[] },
    sendUrl: {},
    deleteUrl: {}
  },
  emits: [
  "previous-invites",
  "send-started",
  "delete-started",
  "delete-completed",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const sendError = ref(false);
const nameError = ref<string | null>(null);
const sending = ref(false);
const deleting = ref(false);
const deleteError = ref(false);

const tagToConfirmDeletion = ref<UserTag | null>(null);

function isEmail(value: string): boolean {
  return EmailRegEx.test(value ? value.trim() : value);
}

watch(
  () => props.userTags,
  (value: UserTag[]) => {
    if (value.length) {
      emit("previous-invites");
    }
  },
);

const tag = ref("");

const rules = {
  tag: { required, email },
};

const state = {
  tag,
};

const v$ = useVuelidate(rules, state, { $autoDirty: true });

const selectedUserTags = ref<UserTag[]>([]);

const sentTagValues = ref<UserTag[] | null>(null);

function markAsSent(sentTag: UserTag): void {
  sentTag.inviteSent = true;
  if (!sentTagValues.value!.some((t) => (t.id || t.text) === (sentTag.id || sentTag.text))) {
    sentTagValues.value!.push(sentTag);
  }
}

// Initialize sentTagValues based on props.userTags
function initializeSentTagValues() {
  if (!sentTagValues.value) {
    sentTagValues.value = [];
    props.userTags.filter((t) => t.inviteSent && t.text).forEach((t) => markAsSent(t));
  }
}

// Call the initialization function when component is created
initializeSentTagValues();

// Watch for changes in userTags and update sentTagValues accordingly
watch(
  () => props.userTags,
  (newTags) => {
    sentTagValues.value = [];
    newTags.filter((t) => t.inviteSent && t.text).forEach((t) => markAsSent(t));
  },
  { immediate: true },
);

const sentTags = computed(() => {
  return sentTagValues.value ?? [];
});

function isValidTag(userTag: UserTag): boolean {
  return !!(userTag.id || isEmail(userTag.text));
}

function performSend(): void {
  if (sending.value) {
    return;
  }

  const tagsToSend: UserTag[] = [{ text: tag.value }];

  selectedUserTags.value.forEach((sut) => {
    sut.text = sut.text ? sut.text.trim() : sut.text;
    sut.email = sut.email ? sut.email.trim() : sut.email;

    if (isValidTag(sut)) {
      tagsToSend.push(sut);
    } else {
      nameError.value = sut.text;
    }
  });

  if (tagsToSend.length === 0) {
    return;
  }

  sending.value = true;
  emit("send-started");

  axios
    .post(
      props.sendUrl,
      tagsToSend.map((t) => t.id || t.text),
    )
    .then((e) => {
      sending.value = false;
      sendError.value = false;
      tag.value = "";
      tagsToSend.forEach((acceptedTag) => {
        markAsSent(acceptedTag);
      });

      selectedUserTags.value = selectedUserTags.value.filter((ut) => !ut.inviteSent); // Clear selectedUserTags
    })
    .catch((e) => {
      sending.value = false;
      sendError.value = true;
    });
}

function send(): void {
  window.setTimeout(() => performSend(), 1); // The reason for this timeout is the way tag creation works.
  // If we didn't have this timeout, if the last tag was still in "text" form, it wouldn't be sent.
}

function cancelDelete(): void {
  if (deleting.value || !props.deleteUrl) {
    return;
  }

  tagToConfirmDeletion.value = null;
}

function deletePending(tagToDelete: UserTag): void {
  if (deleting.value || !props.deleteUrl) {
    return;
  }

  const idOrEmail = tagToDelete.id || tagToDelete.email || tagToDelete.text;
  if (!idOrEmail) {
    return;
  }

  if (tagToConfirmDeletion.value !== tagToDelete) {
    tagToConfirmDeletion.value = tagToDelete;
    return;
  }

  deleting.value = true;
  deleteError.value = false;
  emit("delete-started");

  axios
    .delete(`${props.deleteUrl}?idOrEmail=${encodeURIComponent(idOrEmail)}`)
    .then((e) => {
      deleting.value = false;
      tagToConfirmDeletion.value = null;
      const indexOfDeletedSentTag = sentTags.value.indexOf(tagToDelete);
      if (indexOfDeletedSentTag >= 0) {
        sentTags.value.splice(indexOfDeletedSentTag, 1);
      }
      emit("delete-completed");
    })
    .catch((e) => {
      deleting.value = false;
      tagToConfirmDeletion.value = null;
      deleteError.value = true;
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (sentTags.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentTags.value, (sentTag) => {
              return (_openBlock(), _createElementBlock("p", {
                key: sentTag.id || sentTag.text,
                class: ""
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(sentTag.text), 1),
                _createElementVNode("span", _hoisted_5, [
                  (sentTag.inviteDone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Completed"))
                    : _createCommentVNode("", true),
                  (!sentTag.inviteDone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Sent"))
                    : _createCommentVNode("", true),
                  (
                !sentTag.inviteDone &&
                _ctx.deleteUrl &&
                (tagToConfirmDeletion.value == null || tagToConfirmDeletion.value === sentTag)
              )
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: _normalizeClass(["btn btn-sm delete-button", {
                'btn-default': sentTag !== tagToConfirmDeletion.value,
                'btn-danger': sentTag === tagToConfirmDeletion.value,
              }]),
                        disabled: deleting.value,
                        onClick: ($event: any) => (deletePending(sentTag)),
                        "data-test": "delete-pending-invite",
                        type: "button"
                      }, [
                        (sentTag !== tagToConfirmDeletion.value)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                          : _createCommentVNode("", true),
                        (sentTag === tagToConfirmDeletion.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Sure?"))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_8))
                    : _createCommentVNode("", true),
                  (sentTag === tagToConfirmDeletion.value && !deleting.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "btn btn-sm delete-button btn-default",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelDelete())),
                        type: "button"
                      }, " Cancel "))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("form", {
        class: "col-sm-8 col-sm-offset-1",
        onSubmit: _withModifiers(send, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "",
            placeholder: "Enter an email address",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tag).value = $event)),
            "data-test": "tis-email-input",
            "aria-label": "Enter an email address"
          }, null, 512), [
            [_vModelText, tag.value]
          ])
        ])
      ], 32),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "btn btn-lg btn-default-communication send-invites-button",
          disabled: sending.value || _unref(v$).tag.$invalid,
          onClick: send,
          "data-test": "tis-send-btn",
          type: "button"
        }, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(sending.value ? "Sending..." : " Send "), 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(sending.value ? "..." : " Send "), 1)
        ], 8, _hoisted_14)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        (sendError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, " There was a problem sending the invites. Please check your internet connection and try again. "))
          : _createCommentVNode("", true),
        (deleteError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, " There was a problem deleting the invite. Please check your internet connection and try again. "))
          : _createCommentVNode("", true),
        (nameError.value && selectedUserTags.value.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, " Sorry, we don't have an email address for " + _toDisplayString(nameError.value) + ". ", 1))
          : _createCommentVNode("", true),
        (selectedUserTags.value.length >= 40)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, " Can't send more than 40 invites at once. "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})